import ToolBox from '../ToolBox';
import Template from "ui/Template";
import {i18n} from "ui/i18n";
import {EVENT_SET_COLOR} from "ui/canvas/Canvas";
import Color from "ui/helpers/Color";
import colorPickerView from './color-picker.handlebars';

/**
 * Color Picker element
 */
export default class ColorPicker extends ToolBox {
	/**
	 * Class constructor
	 *
	 * @param {PaletteModel} palette
	 * @param {Object} [options]
	 */
	constructor(palette, options = {}) {
		super(Object.assign({
			title: i18n('title.color-schemes')
		}, options));

		/**
		 * @type {PaletteModel}
		 * @private
		 */
		this._palette = palette;

		this.setBodyElement(
			new Template(colorPickerView)
				.createElement({
					hue: palette.hueColors,
					colors: palette.getColorsByHue(0)
				})
		);

		this._els.colors = this.body.querySelectorAll('.editor-color-picker__color_sl');

		/**
		 * @type {number}
		 * @private
		 */
		this._selectedHue = 0;

		/**
		 * @type {{selectColor: Function}}
		 * @private
		 */
		this._handlers = {
			selectHue: this._onSelectHue.bind(this),
			selectColor: this._onSelectColor.bind(this)
		};

		this._els.colors.forEach((el) => {
			el.addEventListener('click', this._handlers.selectColor);
		});

		this.body.querySelectorAll('.editor-color-picker__color_hue').forEach((el) => {
			el.addEventListener('click', this._handlers.selectHue);
		});

		this.scene.canvas.events.addListener(EVENT_SET_COLOR, this.setColor.bind(this));
		this.setColor(Color.create(this.scene.canvas.colorsSet.getCurrentColor()));
	}

	/**
	 * Sets current draw color
	 *
	 * @param {Color} color
	 * @returns {ColorPicker}
	 */
	setColor(color) {
		for (let el of this.body.querySelectorAll('.editor-color-picker__color_selected')) {
			el.classList.remove('editor-color-picker__color_selected');
		}

		this._setHue(color);

		for (let el of this.body.querySelectorAll(`.editor-color-picker__color[data-color="${color.rgbCss}"]`)) {
			el.classList.add('editor-color-picker__color_selected');
		}
		return this;
	}

	/**
	 * Sets colors by Hue value
	 *
	 * @param {Color} color
	 * @private
	 */
	_setHue(color) {
		if (color.getHSL()[1] === 0) {
			// grayscale color present in each palette. Keep current palette
			let el = this.body.querySelector(`.editor-color-picker__color[data-hue="${this._selectedHue}"]`);
			el.classList.add('editor-color-picker__color_selected');
			return;
		}

		const {hue, colors} = this._palette.getPaletteByColor(color);

		this._selectedHue = hue;

		let el = this.body.querySelector(`.editor-color-picker__color[data-hue="${this._selectedHue}"]`);
		el.classList.add('editor-color-picker__color_selected');

		let i = 0;
		for (let color of colors) {
			let el = this._els.colors[i++];
			if (!el) {
				return;
			}
			el.style.backgroundColor = color.rgbaCss;
			el.setAttribute('data-color', color.rgbCss);
			el.setAttribute('data-alpha', color.alpha);
		}
	}

	/**
	 * Handles click by Hue Color
	 *
	 * @param {MouseEvent} e
	 * @private
	 */
	_onSelectHue(e) {
		this.scene.canvas.setColor(e.target.getAttribute('data-color') || '#000');
	}

	/**
	 * Handles click by color
	 *
	 * @param {MouseEvent} e
	 * @private
	 */
	_onSelectColor(e) {
		let color = e.target.getAttribute('data-color') || '#000',
			alpha = parseFloat(e.target.getAttribute('data-alpha'));

		if (alpha === 0.0) {
			this.scene.canvas.setColor(color, 0);
		} else {
			this.scene.canvas.setColor(color);
		}
	}
}
